import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors } from "../constants/GlobalStyles";

const IconBackpack = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 16}
    height={props.height || 16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1791_33131)">
      <path
        d="M6.57143 5.00183V4.33516C6.57143 3.98154 6.72194 3.6424 6.98985 3.39236C7.25776 3.14231 7.62112 3.00183 8 3.00183C8.37888 3.00183 8.74224 3.14231 9.01015 3.39236C9.27806 3.6424 9.42857 3.98154 9.42857 4.33516V5.00183M5.85714 15.0018V12.3352C5.85714 11.9815 6.00765 11.6424 6.27556 11.3924C6.54347 11.1423 6.90683 11.0018 7.28571 11.0018H8.71429C9.09317 11.0018 9.45653 11.1423 9.72444 11.3924C9.99235 11.6424 10.1429 11.9815 10.1429 12.3352V15.0018M7.28571 7.6685H8.71429M3 13.0018V9.00183C3 7.94097 3.45153 6.92355 4.25526 6.1734C5.05898 5.42326 6.14907 5.00183 7.28571 5.00183H8.71429C9.85093 5.00183 10.941 5.42326 11.7447 6.1734C12.5485 6.92355 13 7.94097 13 9.00183V13.0018C13 13.5323 12.7742 14.041 12.3724 14.416C11.9705 14.7911 11.4255 15.0018 10.8571 15.0018H5.14286C4.57454 15.0018 4.02949 14.7911 3.62763 14.416C3.22576 14.041 3 13.5323 3 13.0018Z"
        stroke={props.color || colors.secondaryAction.default}
        strokeWidth={props.strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1791_33131">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconBackpack;
